"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable import/prefer-default-export */

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var media_query_1 = require("../utils/media-query");

var GridWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  box-sizing: border-box;\n  flex: ", ";\n  padding-bottom: ", ";\n\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n\n  ", ";\n"], ["\n  box-sizing: border-box;\n  flex: ", ";\n  padding-bottom: ", ";\n\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), function (p) {
  return p.flex || '0 1 auto';
}, function (p) {
  return media_query_1.isNumber(p.paddingBottom) ? p.paddingBottom + "px" : p.paddingBottom;
}, function (p) {
  return media_query_1.makeStyledMediaQueryGap('margin', p, true);
}, function (p) {
  return media_query_1.makeStyledMediaQuery('justifyContent', p);
}, function (p) {
  return media_query_1.makeStyledMediaQuery('flexDirection', p);
}, function (p) {
  return media_query_1.makeStyledMediaQuery('flexWrap', p);
}, function (p) {
  return media_query_1.makeStyledMediaQuery('display', p);
}, function (p) {
  return media_query_1.makeStyledMediaQuery('alignItems', p);
}, function (p) {
  return media_query_1.makeStyledMediaQuery('alignContent', p);
}, function (p) {
  return p.first && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      order: -1;\n    "], ["\n      order: -1;\n    "])));
}, function (p) {
  return p.last && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      order: 1;\n    "], ["\n      order: 1;\n    "])));
});

exports.Grid = function (_a) {
  var children = _a.children,
      rest = __rest(_a, ["children"]);

  var renderChildren = function () {
    return react_1.default.Children.map(children, function (child) {
      return react_1.default.cloneElement(child, {
        gap: rest.gap,
        columns: rest.columns
      });
    });
  };

  return react_1.default.createElement(GridWrapper, __assign({}, rest), renderChildren());
};

exports.Grid.defaultProps = {
  gap: 16,
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  columns: 12,
  paddingBottom: 16
};
var templateObject_1, templateObject_2, templateObject_3;